var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPregnant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 7.6875C13.0833 6.47913 14.0158 5.5 15.1666 5.5C16.3175 5.5 17.25 6.47913 17.25 7.6875C17.25 8.89587 16.3175 9.875 15.1666 9.875C14.0158 9.875 13.0833 8.89587 13.0833 7.6875ZM21 18.1875C21 19.6864 20.2117 22.1355 20.1208 22.4102C20.005 22.7629 19.6883 23 19.3333 23H17.6666V25.625C17.6666 26.108 17.2941 26.5 16.8333 26.5C16.3725 26.5 16 26.108 16 25.625V23H14.3333V25.625C14.3333 26.108 13.9608 26.5 13.4999 26.5C13.0391 26.5 12.6666 26.108 12.6666 25.625V22.8355C12.2716 22.6876 11.9091 22.4496 11.6258 22.1128C11.1516 21.5484 10.9308 20.7968 11.0191 20.0504L11.7633 13.8029C11.9699 12.0625 13.3858 10.7509 15.0558 10.7509C16.7258 10.7509 18.1416 12.0634 18.3483 13.8029L18.3533 13.8449C19.9567 14.6289 21 16.3089 21 18.1875ZM19.3333 18.1875C19.3333 16.875 18.5266 15.713 17.3266 15.2956C17.0225 15.1897 16.8025 14.9097 16.7616 14.5746L16.695 14.0199C16.5916 13.1528 15.8866 12.4991 15.0558 12.4991C14.225 12.4991 13.5199 13.1527 13.4166 14.0181L13.2566 15.3604L15.6283 17.0203C16.0116 17.288 16.115 17.8314 15.8591 18.2339C15.6991 18.4868 15.4341 18.6233 15.165 18.6233C15.0066 18.6233 14.8458 18.576 14.7033 18.4762L13.0249 17.3011L12.6724 20.2648C12.6424 20.5176 12.7141 20.7617 12.8741 20.9525C13.0341 21.1432 13.2566 21.2482 13.4991 21.2482H18.725C18.9825 20.368 19.3325 18.9881 19.3325 18.1858L19.3333 18.1875Z",
    fill: "#4DBBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnant);
export default __webpack_public_path__ + "static/media/Pregnant.01c6267269dfb502ab50de8ca7866959.svg";
export { ForwardRef as ReactComponent };